import { Stat } from "@kkp/ui";
import type { CompanyStats } from "@kkp/features";

export function ClientsStats({ stats }: { stats: CompanyStats }) {
  return (
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
      <Stat label="Total companies" value={`${stats.total}`} />
      <Stat label="Active" value={`${stats.active}`} note="Operational" />
      <Stat label="Inactive" value={`${stats.inactive}`} note="Disabled" />
    </div>
  );
}
